var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 4.20039C7.69208 4.20039 4.1999 7.69257 4.1999 12.0004C4.1999 16.3082 7.69208 19.8004 11.9999 19.8004C16.3077 19.8004 19.7999 16.3082 19.7999 12.0004C19.7999 10.8498 19.5508 9.75749 19.1036 8.7743L12.0246 15.6103L11.9675 15.5511L7.85674 11.2964L9.15156 10.046L12.0638 13.0703L18.1458 7.19692C16.7181 5.37278 14.4959 4.20039 11.9999 4.20039ZM11.9999 21.6004C6.69797 21.6004 2.3999 17.3023 2.3999 12.0004C2.3999 6.69846 6.69797 2.40039 11.9999 2.40039C17.3018 2.40039 21.5999 6.69846 21.5999 12.0004C21.5999 17.3023 17.3018 21.6004 11.9999 21.6004Z",
    fill: "#5AB52F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.ae09b7d7.svg";
export { ForwardRef as ReactComponent };